/**
 * Mock SoHo Entity database for competitor search prototype.
 * Replace with API search when backend is available.
 */

export const SOHO_ENTITY_DATABASE = [
  {
    id: 'entity-atlantis',
    property: 'Atlantis Paradise Island',
    type: 'Luxury Resort',
    location: 'Nassau, Bahamas',
    brand: 'Atlantis',
    subBrand: 'Paradise Island',
    websiteUrl: 'https://www.atlantisbahamas.com',
    tripadvisorUrl: 'https://www.tripadvisor.com/Hotel_Review-g147416-d150524-Reviews-Atlantis_Paradise_Island-Nassau_New_Providence_Island_Bahamas.html',
    socialChannels: [
      { channel: 'instagram_graph', url: 'https://instagram.com/atlantisbahamas' },
      { channel: 'facebook', url: 'https://facebook.com/Atlantisbahamas' },
      { channel: 'tiktok', url: 'https://tiktok.com/@atlantisbahamas' },
      { channel: 'linkedin', url: 'https://linkedin.com/company/atlantis-paradise-island' },
    ],
  },
  {
    id: 'entity-ocean-club',
    property: 'Ocean Club Four Seasons',
    type: 'Luxury Resort',
    location: 'Nassau, Bahamas',
    brand: 'Four Seasons',
    subBrand: 'Ocean Club',
    websiteUrl: 'https://www.fourseasons.com/oceanclub',
    tripadvisorUrl: 'https://www.tripadvisor.com/Hotel_Review-g147416-d150525-Reviews-The_Ocean_Club_A_Four_Seasons_Resort-Nassau_New_Providence_Island_Bahamas.html',
    socialChannels: [
      { channel: 'instagram_graph', url: 'https://instagram.com/fourseasons' },
      { channel: 'facebook', url: 'https://facebook.com/fourseasons' },
      { channel: 'linkedin', url: 'https://linkedin.com/company/four-seasons-hotels-and-resorts' },
    ],
  },
  {
    id: 'entity-rosewood-baha-mar',
    property: 'Rosewood Baha Mar',
    type: 'Luxury Resort',
    location: 'Nassau, Bahamas',
    brand: 'Rosewood',
    subBrand: 'Baha Mar',
    websiteUrl: 'https://www.rosewoodhotels.com/en/baha-mar',
    tripadvisorUrl: 'https://www.tripadvisor.com/Hotel_Review-g147416-d10064645-Reviews-Rosewood_Baha_Mar-Nassau_New_Providence_Island_Bahamas.html',
    socialChannels: [
      { channel: 'instagram_graph', url: 'https://instagram.com/rosewoodhotels' },
      { channel: 'facebook', url: 'https://facebook.com/rosewoodhotels' },
      { channel: 'tiktok', url: 'https://tiktok.com/@rosewoodhotels' },
    ],
  },
  {
    id: 'entity-fontainebleau',
    property: 'Fontainebleau Miami Beach',
    type: 'Beach Resort',
    location: 'Miami Beach, FL',
    brand: 'Fontainebleau',
    subBrand: 'Miami Beach',
    websiteUrl: 'https://www.fontainebleau.com',
    tripadvisorUrl: 'https://www.tripadvisor.com/Hotel_Review-g34439-d85800-Reviews-Fontainebleau_Miami_Beach-Miami_Beach_Florida.html',
    socialChannels: [
      { channel: 'instagram_graph', url: 'https://instagram.com/fontainebleau' },
      { channel: 'facebook', url: 'https://facebook.com/fontainebleau' },
      { channel: 'twitter', url: 'https://twitter.com/fontainebleau' },
    ],
  },
  {
    id: 'entity-bellagio',
    property: 'Bellagio Las Vegas',
    type: 'Casino Resort',
    location: 'Las Vegas, NV',
    brand: 'MGM Resorts',
    subBrand: 'Bellagio',
    websiteUrl: 'https://www.bellagio.com',
    tripadvisorUrl: 'https://www.tripadvisor.com/Hotel_Review-g45963-d108777-Reviews-Bellagio_Las_Vegas-Las_Vegas_Nevada.html',
    socialChannels: [
      { channel: 'instagram_graph', url: 'https://instagram.com/bellagio' },
      { channel: 'facebook', url: 'https://facebook.com/bellagio' },
      { channel: 'youtube', url: 'https://youtube.com/@bellagio' },
    ],
  },
  {
    id: 'entity-diplomat',
    property: 'Diplomat Beach Resort',
    type: 'Beach Resort',
    location: 'Hollywood, FL',
    brand: 'Curio Collection by Hilton',
    subBrand: 'Diplomat Beach Resort',
    websiteUrl: 'https://www.hilton.com/en/hotels/flldkqq-diplomat-beach-resort/',
    tripadvisorUrl: 'https://www.tripadvisor.com/Hotel_Review-g34227-d85845-Reviews-Diplomat_Beach_Resort-Hollywood_Broward_County_Florida.html',
    socialChannels: [
      { channel: 'instagram_graph', url: 'https://instagram.com/diplomatresort' },
      { channel: 'facebook', url: 'https://facebook.com/diplomatresort' },
    ],
  },
  {
    id: 'entity-waldorf-bahamas',
    property: 'Waldorf Astoria Bahamas',
    type: 'Luxury Resort',
    location: 'Nassau, Bahamas',
    brand: 'Waldorf Astoria',
    subBrand: 'Bahamas',
    websiteUrl: 'https://www.hilton.com/en/hotels/naswawa-waldorf-astoria-bahamas/',
    tripadvisorUrl: 'https://www.tripadvisor.com/Hotel_Review-g147416-d25278642-Reviews-Waldorf_Astoria_Bahamas-Nassau_New_Providence_Island_Bahamas.html',
    socialChannels: [
      { channel: 'instagram_graph', url: 'https://instagram.com/waldorfastoria' },
      { channel: 'facebook', url: 'https://facebook.com/waldorfastoria' },
      { channel: 'linkedin', url: 'https://linkedin.com/company/waldorf-astoria' },
    ],
  },
  {
    id: 'entity-sls-baha-mar',
    property: 'SLS Baha Mar',
    type: 'Luxury Resort',
    location: 'Nassau, Bahamas',
    brand: 'SLS Hotels',
    subBrand: 'Baha Mar',
    websiteUrl: 'https://www.slsbahamar.com',
    tripadvisorUrl: 'https://www.tripadvisor.com/Hotel_Review-g147416-d10064646-Reviews-SLS_Baha_Mar-Nassau_New_Providence_Island_Bahamas.html',
    socialChannels: [
      { channel: 'instagram_graph', url: 'https://instagram.com/slsbaha' },
      { channel: 'facebook', url: 'https://facebook.com/slsbaha' },
      { channel: 'tiktok', url: 'https://tiktok.com/@slsbaha' },
    ],
  },
  {
    id: 'entity-edition-miami',
    property: 'The Miami Beach EDITION',
    type: 'Boutique Hotel',
    location: 'Miami Beach, FL',
    brand: 'EDITION Hotels',
    subBrand: 'Miami Beach',
    websiteUrl: 'https://www.editionhotels.com/miami-beach/',
    tripadvisorUrl: 'https://www.tripadvisor.com/Hotel_Review-g34439-d1957007-Reviews-The_Miami_Beach_EDITION-Miami_Beach_Florida.html',
    socialChannels: [
      { channel: 'instagram_graph', url: 'https://instagram.com/editionhotels' },
      { channel: 'facebook', url: 'https://facebook.com/editionhotels' },
    ],
  },
  {
    id: 'entity-1-hotel-south-beach',
    property: '1 Hotel South Beach',
    type: 'Beach Resort',
    location: 'Miami Beach, FL',
    brand: '1 Hotels',
    subBrand: 'South Beach',
    websiteUrl: 'https://www.1hotels.com/south-beach',
    tripadvisorUrl: 'https://www.tripadvisor.com/Hotel_Review-g34439-d656520-Reviews-1_Hotel_South_Beach-Miami_Beach_Florida.html',
    socialChannels: [
      { channel: 'instagram_graph', url: 'https://instagram.com/1hotels' },
      { channel: 'facebook', url: 'https://facebook.com/1hotels' },
      { channel: 'linkedin', url: 'https://linkedin.com/company/1-hotels' },
    ],
  },
]

export function searchSohoEntities(query, { excludeProperties = [] } = {}) {
  const normalizedQuery = String(query || '').trim().toLowerCase()
  const excluded = new Set(excludeProperties.map((name) => name.toLowerCase()))

  return SOHO_ENTITY_DATABASE.filter((entity) => {
    if (excluded.has(entity.property.toLowerCase())) return false
    const haystack = `${entity.property} ${entity.type} ${entity.location} ${entity.brand || ''} ${entity.subBrand || ''}`.toLowerCase()
    if (!normalizedQuery) return true
    return haystack.includes(normalizedQuery)
  }).slice(0, 8)
}

export function entityToCompetitorDraft(entity) {
  return {
    entityId: entity.id,
    property: entity.property,
    type: entity.type,
    location: entity.location,
    brand: entity.brand || '',
    subBrand: entity.subBrand || '',
    websiteUrl: entity.websiteUrl || '',
    tripadvisorUrl: entity.tripadvisorUrl || '',
    socialChannels: (entity.socialChannels || []).map((sc, index) => ({
      id: `sc-entity-${entity.id}-${index}`,
      channel: sc.channel,
      url: sc.url,
    })),
  }
}
